/**
 * Accelerator Filter Module
 * Handles filtering, search, and load more functionality for accelerators block
 * 
 * @package RadianHub
 */

export function initAcceleratorFilter() {
    const filterContainer = document.querySelector('.accelerator-filters');
    if (!filterContainer) return;
    
    const grid = document.getElementById('accelerators-grid');
    const loadMoreBtn = document.getElementById('load-more-accelerators');
    
    if (!grid) return;
    
    let currentPage = 1;
    let isLoading = false;
    let activeType = null; // Single selected type instead of array
    
    // Get active filter radio button
    function getActiveType() {
        // Get checked radio button
        const radio = filterContainer.querySelector('.accelerator-filter-radio:checked');
        
        if (radio) {
            const termId = parseInt(radio.getAttribute('data-term-id'));
            return termId;
        }
        
        return null;
    }
    
    // Load accelerators via AJAX
    function loadAccelerators(page = 1, append = false) {
        if (isLoading) return;
        
        isLoading = true;
        currentPage = page;
        
        // Update button state
        if (loadMoreBtn) {
            loadMoreBtn.disabled = true;
            loadMoreBtn.textContent = 'Loading...';
        }
        
        // Prepare data
        const data = {
            action: 'radianhub_filter_accelerators',
            nonce: window.radianhub_ajax?.nonce || '',
            page: page,
            type_term: activeType || '' // Send single type ID or empty string
        };
        
        // Make AJAX request
        fetch(window.radianhub_ajax?.ajax_url || '/wp-admin/admin-ajax.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(data)
        })
        .then(response => {
            // Check if response is actually JSON
            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                return response.text().then(text => {
                    // Non-JSON response from server
                    throw new Error('Server returned non-JSON response. Check console for details.');
                });
            }
            return response.json();
        })
        .then(result => {
            // Handle both wp_send_json and wp_send_json_success formats
            const data = result.data || result;
            const success = result.success !== undefined ? result.success : (data && data.success !== undefined ? data.success : true);
            
            if (success && data) {
                if (append) {
                    grid.insertAdjacentHTML('beforeend', data.posts || '');
                } else {
                    grid.innerHTML = data.posts || '';
                }
                
                // Update load more button
                if (loadMoreBtn) {
                    if (data.has_more) {
                        loadMoreBtn.disabled = false;
                        loadMoreBtn.textContent = 'Load More';
                        loadMoreBtn.setAttribute('data-page', data.current_page || page);
                        loadMoreBtn.setAttribute('data-total', data.found_posts || 0);
                        loadMoreBtn.closest('div').style.display = 'block';
                    } else {
                        loadMoreBtn.closest('div').style.display = 'none';
                    }
                }
            } else {
                // Error loading accelerators
                if (!append) {
                    grid.innerHTML = '<p class="col-span-full">No accelerators found.</p>';
                }
            }
        })
        .catch(error => {
            // AJAX error occurred
            if (!append) {
                grid.innerHTML = '<p class="col-span-full">Error loading accelerators. Please try again.</p>';
            }
        })
        .finally(() => {
            isLoading = false;
            if (loadMoreBtn) {
                loadMoreBtn.disabled = false;
                loadMoreBtn.textContent = 'Load More';
            }
        });
    }
    
    // Handle filter radio button changes
    function handleFilterChange() {
        activeType = getActiveType();
        loadAccelerators(1, false); // Reset to page 1
    }
    
    // Event listeners
    if (filterContainer) {
        // Radio button changes
        filterContainer.addEventListener('change', (e) => {
            if (e.target.classList.contains('accelerator-filter-radio')) {
                handleFilterChange();
            }
        });
        
        // Label clicks - toggle radio button and filter
        filterContainer.addEventListener('click', (e) => {
            // Check if click is on label or span inside label
            const label = e.target.closest('.accelerator-filter-label');
            if (label) {
                // Don't handle if clicking directly on radio button (let default behavior work)
                if (e.target.classList.contains('accelerator-filter-radio')) {
                    return;
                }
                
                e.preventDefault();
                e.stopPropagation();
                
                const radio = label.querySelector('.accelerator-filter-radio');
                if (radio) {
                    // If already checked, uncheck it (toggle off)
                    if (radio.checked) {
                        radio.checked = false;
                    } else {
                        // Otherwise, check it
                        radio.checked = true;
                    }
                    // Manually trigger filter change
                    handleFilterChange();
                }
            }
        });
    }
    
    // Load more button
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => {
            const nextPage = currentPage + 1;
            loadAccelerators(nextPage, true); // Append to existing
        });
    }
    
    // Initialize active type
    activeType = getActiveType();
}
